export default __webpack_public_path__ + "static/media/M02.daf940cf.jpg";